<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Vicki Kelly lived the first part of her life in New Zealand before moving to the UK in 2004. She has previously worked as a teacher, a farmer, a gardener, a caterer and holds a master’s degree in environmental law. She has four grown-up children, half a dozen grandchildren and a Jack Russell terrier. She is married to Peter Watson.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?081ece9a